import { AlertTriangle, AlertCircle, Info, ArrowUpRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';

export function OpenIssuesWidget({ issues, loading }) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <Card className="gds-card">
        <CardHeader>
          <CardTitle className="font-heading text-sm flex items-center gap-2">
            <AlertTriangle className="w-4 h-4 text-amber-500" />
            Open SEO Issues
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="h-12 rounded-lg bg-slate-100 dark:bg-slate-800 animate-pulse" />
            ))}
          </div>
        </CardContent>
      </Card>
    );
  }

  const total = (issues?.critical || 0) + (issues?.high || 0) + (issues?.medium || 0);

  const tiers = [
    {
      label: 'Critical',
      count: issues?.critical || 0,
      icon: AlertCircle,
      bg: 'bg-red-50 dark:bg-red-900/20',
      text: 'text-red-700 dark:text-red-400',
      icon_color: 'text-red-500',
    },
    {
      label: 'High',
      count: issues?.high || 0,
      icon: AlertTriangle,
      bg: 'bg-amber-50 dark:bg-amber-900/20',
      text: 'text-amber-700 dark:text-amber-400',
      icon_color: 'text-amber-500',
    },
    {
      label: 'Medium',
      count: issues?.medium || 0,
      icon: Info,
      bg: 'bg-blue-50 dark:bg-blue-900/20',
      text: 'text-blue-700 dark:text-blue-400',
      icon_color: 'text-blue-500',
    },
  ];

  return (
    <Card className="gds-card">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="font-heading text-sm flex items-center gap-2">
          <AlertTriangle className="w-4 h-4 text-amber-500" />
          Open SEO Issues
        </CardTitle>
        {total > 0 && (
          <Button
            variant="ghost"
            size="sm"
            className="text-xs h-7"
            onClick={() => navigate('/dashboard/onpage')}
          >
            Fix Now
            <ArrowUpRight className="w-3 h-3 ml-1" />
          </Button>
        )}
      </CardHeader>
      <CardContent>
        {total === 0 ? (
          <div className="text-center py-4">
            <p className="text-sm text-emerald-600 font-medium">All clear! No open issues.</p>
            <p className="text-xs text-slate-500 mt-1">Run an on-page scan to check your site</p>
          </div>
        ) : (
          <div className="space-y-2">
            {tiers.map(({ label, count, icon: Icon, bg, text, icon_color }) =>
              count > 0 ? (
                <div
                  key={label}
                  className={`flex items-center justify-between p-3 rounded-lg ${bg} cursor-pointer hover:opacity-80 transition-opacity`}
                  onClick={() => navigate('/dashboard/onpage')}
                >
                  <div className="flex items-center gap-2">
                    <Icon className={`w-4 h-4 ${icon_color}`} />
                    <span className={`text-sm font-medium ${text}`}>{label}</span>
                  </div>
                  <span className={`text-lg font-bold font-heading ${text}`}>{count}</span>
                </div>
              ) : null
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
